import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHeading } from '../../components/Dashboard/Content/ContentCommonFunctions';
import { Content, ContentInteractionAction } from '../models/content/Content';
import { useCustomEventTracking } from '../useCustomEventTracking';
import { useScrollRestoration } from './useScrollRestoration';
import { useNavigationUtils } from '../utils/useNavigationUtils';

// Fires the content Open interaction used by engagement analytics and recommendations
export const useTrackContentOpened = () => {
  const { trackContentInteraction } = useCustomEventTracking();

  return useCallback((content: Content) => {
    trackContentInteraction(
      ContentInteractionAction.Open,
      content?.attributes?.type?.replace(/^\w/, (c) => c.toUpperCase()),
      {
        contentId: content?.id,
        contentTitle: content?.attributes?.title || '',
        contentCreatorName: getHeading(content) || '',
        contentMetaData: content?.attributes?.metadata || [],
        type: content?.attributes?.type,
        ...(content?.contentFeedSection && { contentFeedSection: content?.contentFeedSection }),
        ...(content?.contentFeedSectionPosition &&
          { contentFeedSectionPosition: content?.contentFeedSectionPosition }),
      },
    );
  }, [trackContentInteraction]);
};

export const useDisplayContentView = () => {
  const navigate = useNavigate();
  const { saveScroll } = useScrollRestoration();
  const { openExternalLink } = useNavigationUtils();
  const trackContentOpenedEvent = useTrackContentOpened();

  const displayContentView = (
    content: Content,
  ) => {
    if (content?.attributes?.type?.toUpperCase() !== 'PODCAST') {
      if (content?.attributes?.external_link && content?.attributes?.external_link.target) {
        openExternalLink(content?.attributes?.external_link.target);
        // track event
        trackContentOpenedEvent(content);
      } else if (content?.attributes?.video_url) {
        openExternalLink(content?.attributes?.video_url);
        trackContentOpenedEvent(content);
      } else {
        trackContentOpenedEvent(content);
        saveScroll();
        navigate(`/content/${content?.id}`, {
          state: {
            homeLayoutV2: true,
          },
        });
      }
    }
  };

  return displayContentView;
};
